// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._v56410bs{transition:opacity .2s ease-out,visibility .2s ease-out,transform .2s ease-out}._1bsb1ns9{width:-moz-fit-content;width:fit-content}\n._1e0c1txw{display:flex}\n._3um015vq{visibility:hidden}\n._4cvr1h6o{align-items:center}\n._lcxvglyw{pointer-events:none}\n._m6k4gioh{will-change:opacity,visibility,transform}\n._t9ecmk3q{transform:translate3d(0,0,0) perspective(1px)}\n._tzy4idpf{opacity:0}\n._w6ng15vq{backface-visibility:hidden}", ""]);
// Exports
module.exports = exports;
